// extracted by mini-css-extract-plugin
export var mediaInfo = "style-mod--media-info--b332c";
export var mediaInfoContent = "style-mod--media-info-content--5018e";
export var mediaInfoDescription = "style-mod--media-info-description--010d0";
export var mediaInfoFigure = "style-mod--media-info-figure--20491";
export var mediaInfoImg = "style-mod--media-info-img--4665f";